// extracted by mini-css-extract-plugin
module.exports = {"selectable":"SettingsPanel_selectable__7LmBZ","selected":"SettingsPanel_selected__e0kxG","filterName":"SettingsPanel_filterName__FeBEN"};